import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverflowEllipsisComponent } from './overflow-ellipsis.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    OverflowEllipsisComponent
  ],
  declarations: [OverflowEllipsisComponent]
})
export class OverflowEllipsisModule { }
